<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>
<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item custom">
    <h1>
      „დღეს ტენე პლასტმასა?“ – კითხვა რომელიც თანამშრომლების ყოველდღიურობის ნაწილი გახდა
    </h1>
    <h6>ივლისი 2023</h6>
    <br />

    <p>
      დაახლოებით 3 თვის წინ თიბისი ლიზინგის შენობაში მწვანე ყუთები „აქ ტენე პლასტმასა“ - მოწოდებით გამოჩნდა. კი, სწორად
      მიხვდით, ზუსტად ეს დროა გასული მას შემდეგ, რაც სიხარულით ვამცნეთ თანამშრომლებს და შემდეგ უკვე საზოგადოებას, რომ
      გარემოზე ზრუნვის მოტივით „ტენეს“ დავუმეგობრდით. არანაკლები ენთუზიაზმით ჩავწერეთ მოკლე საინფორმაციო ვიდეოები
      ერთჯერადი ჭიქების კოლექტორის და მწვანე ყუთების დატვირთვის შესახებ და ზარ-ზეიმით აღვნიშნეთ პირველი მისიის
      შესრულებაც. გადავწყვიტეთ, რომ კარგ ამბებს გაზიარება უხდება და ჩვენი თანამშრომლები საკუთარ გამოცდილებაზე
      მოგიყვებიან, თუმცა იქამდე, რამდენიმე ფაქტზე გავამახვილებთ თქვენს ყურადღებას.
    </p>

    <img src="../../../../assets/blog/recycling/img1.jpg" alt="" />

    <p>
      დიდი ხანია, რაც გარემოს დაცვა არჩევანი არ არის, ეს ერთგვარი ვალდებულებაა, რომელსაც დედამიწის ნებისმიერ კუთხეში
      მცხოვრები ადამიანები ვიზიარებთ. ყველაზე დიდი საფრთხე კი, მაშინ დგება, როცა ვფიქრობთ რომ ჩვენს მაგივრად სხვა
      იზრუნებს ამ საკითხზე. თავი რომ არ შეგაწყინოთ, გეტყვით, რომ:
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-middle-green">
      <div class="container">
        <ul class="pointed-list">
          <li>ყოველწლიურად დაახლოებით 380 მილიონი ტონა პლასტმასა იწარმოება;</li>
          <li>
            Plasticoceans.org-ის მიხედვით, ამ რიცხვის 50%-მდე ერთჯერადი მოხმარების ნივთების დასამზადებლადაა განკუთვნილი;
          </li>
          <li>
            ადამიანები ერთხელ ვსვამთ წყალს პლასტმასას ჭიქიდან, ვიყენებთ ფერად-ფერად საწრუპებს და ერთჯერად თეფშებს, თუმცა
            მათ დაშლას შესაძლოა 20-დან 500 წლამდე დასჭირდეს;
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      კვლევების მიხედვით, აღნიშნული ციფრები ასე გამოიყურება: ერთჯერადი ცელოფანი - 20 წელი, საწრუპი - 200 წელი, ბოთლი -
      450 წელი, პლასტმასას კბილის ჯაგრისი - 500 წელი.
    </p>

    <p>
      პლასტმასას ნარჩენები უარყოფით გავლენას ახდენს ადამიანებზე, ეკოსისტემასა და კლიმატის ცვლილებაზე, რა საკითხებზეც
      მოგვიანებით, კიდევ უფრო დეტალურად მოგიყვებით. იქამდე კი, ტენეს კიდევ ერთხელ გაგაცნობთ:
    </p>

    <p>
      ტენე არის პირველი ქართული და ამავდროულად მსოფლიოში პირველი ეკომეგობრული USB კაბელი, რომლის მიზანიც კლიმატის
      ცვლილების წინააღმდეგ ბრძოლაა.
    </p>

    <p>
      აღნიშნული მიზნის მისაღწევად ტენე მოსახლეობისგან სხვადასხვა სახის წახალისების გზით, იბარებს საყოფაცხოვრებო მყარ
      ნარჩენს, რომელსაც მოგვიანებით გადაამუშავებს და კაბელებს ამზადებს.
    </p>

    <p style="font-size: 24px">
      <b class="middle-green"> ჩვენი თანამშრომლების #გამოცდილება</b>
    </p>

    <img src="../../../../assets/blog/recycling/img2.jpg" alt="" />

    <p class="quote-sign middle-green">“</p>

    <p>
      <b>
        მას შემდეგ, რაც მწვანე ყუთები გამოჩნდა ჩვენს შენობაში, ყოველდღიურობას ახალი აქტივობა და „როგორ ხარ“-ის შემდეგ
        საკითხავი „დღეს ტენე პლასტმასა?!“ დაემატა. იმდენად გადამდები მუხტი აქვს ამ მნიშვნელოვანი იდეის გარშემო ჩვენს
        გაერთიანებას, რომ ყოველ ავლა-ჩავლაზე ვაკვირდები, რომელი დეპარტამენტი ყოჩაღობს და აქტიურად ავსებს „ტენეს“
        კოლექტორებს.
      </b>
    </p>

    <p class="right-align">თაკო, ოპერაციების სპეციალისტი</p>

    <p class="quote-sign middle-green">“</p>

    <p>
      <b>
        თავდაპირველად მეტ-ნაკლებად სკეპტიკურად ვიყავი განწყობილი ახალი წამოწყებისადმი, რადგან ჩვენდა სამწუხაროდ,
        სეპარაციის კულტურა თუ შესაძლებლობა ამ ეტაპზე საქართველოში ნაკლებად გვაქვს, თუმცა ის რაც ამ სამი თვის მანძილზე
        ვნახე, რადიკალურად განსხვავებულს მოწმობს. დღიდან-დღემდე ვაკვირდებით ყუთებში შეგროვებული პლასტმასას რაოდენობრივ
        პროგრესს და ვფიქრობთ ახალ ინიციატივებზე, რომელიც კიდევ უფრო გააძლიერებს გარემოზე ზრუნვის ინიციატივას
      </b>
    </p>

    <p class="right-align">მარიამი, მომხმარებლებთან ურთიერთობის სპეციალისტი</p>

    <img src="../../../../assets/blog/recycling/img3.jpg" alt="" />

    <p class="quote-sign middle-green">“</p>

    <p>
      <b>
        შესაძლოა მკითხველისთვის უცნაური იყოს ის, რასაც ვიტყვი, მაგრამ ლიზინგი ერთ-ერთი ყველაზე მწვანე პროდუქტია, რადგან
        ნივთების მოკლე პერიოდით, ერთი მეპატრონის მიერ ფლობას კი არ ახალისებს, მდგრადობის პრინციპით მოქმედებს. ის, რაც
        აღარ გჭირდება შენ - შესაძლოა სარგებლის მომტანი იყოს სხვისთვის. სწორედ ამიტომ, განსაკუთრებული ენთუზიაზმით
        ვერთვებით ინიციატივებში, რაც გარემოს დაცვას და ადამიანური ზიანის შემცირებას მოიაზრებს.
      </b>
    </p>

    <p class="right-align">ია, სამშენებლო და ჯანდაცვის სექტორის უფროსი</p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-middle-green">
      <div class="container">
        <p class="quote">
          წარმატებული დამეგობრება მხოლოდ დასაწყისია იმ პროექტების და აქტივობების, რომლის შთაგონებაც ჩვენი თანამშრომლების
          უკუკავშირმა მოგვცა. სწორედ ამიტომ, გვადევნეთ თვალი და გაეცანით სიახლეებს, რომელსაც მწვანე ინიციატივების
          მიმართულებით დავგეგმავთ.
        </p>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item custom">
    <h1>
      „Tene Plastics Today?“ – A question that has become part of employees' daily routine
    </h1>
    <h6>July 2023</h6>
    <br />

    <p>
      About 3 months ago, green boxes with the slogan "Here Tene Plastics" appeared in the TBC Leasing office. Yes, you
      guessed it correctly, it has been exactly this long since we happily informed our employees and then the public
      that we became friends with "Tene" with the motivation of caring for the environment. With equal enthusiasm, we
      recorded short informational videos about the collector for disposable cups and the loading of green boxes, and we
      celebrated the completion of the first mission with fanfare. We decided that good news deserves to be shared, and
      our employees will tell you about their own experience, but before that, we will draw your attention to a few
      facts.
    </p>

    <img src="../../../../assets/blog/recycling/img1.jpg" alt="" />

    <p>
      It has long been the case that environmental protection is no longer a choice; it is an obligation shared by
      people living in every corner of the Earth. The greatest danger arises when we think that someone else will take
      care of this issue on our behalf. To avoid boring you, I’ll tell you that:
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-middle-green">
      <div class="container">
        <ul class="pointed-list">
          <li>Approximately 380 million tons of plastic are produced annually;</li>
          <li>
            According to Plasticoceans.org, up to 50% of this amount is intended for the production of single-use items;
          </li>
          <li>
            People drink water from plastic cups, use colorful straws and disposable plates, but it can take anywhere
            from 20 to 500 years for them to decompose;
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p>
      According to research, these are the figures for decomposition: single-use cellophane – 20 years, straw – 200
      years, bottle – 450 years, plastic toothbrush – 500 years.
    </p>

    <p>
      Plastic waste has a negative impact on humans, ecosystems, and climate change, about which we will tell you in
      more detail later. Before that, let me introduce Tene to you once again:
    </p>

    <p>
      Tene is the first Georgian and also the world’s first eco-friendly USB cable, whose mission is to fight climate
      change.
    </p>

    <p>
      To achieve this goal, Tene collects household solid waste from the population through various incentives, which is
      later recycled to make cables.
    </p>

    <p style="font-size: 24px">
      <b class="middle-green">Our employees' experience.</b>
    </p>

    <img src="../../../../assets/blog/recycling/img2.jpg" alt="" />

    <p class="quote-sign middle-green">“</p>

    <p>
      <b>
        Since the green boxes appeared in our building, a new activity has been added to our daily routine, and after
        "How are you," the question "Did you collect plastic today?!" has become common. The energy around this
        important idea is so contagious within our community that I observe which department is doing well and actively
        filling the “Tene” collectors every time I pass by.
      </b>
    </p>

    <p class="right-align">Tako, Operations Specialist</p>

    <p class="quote-sign middle-green">“</p>

    <p>
      <b>
        At first, I was somewhat skeptical about the new initiative because, unfortunately, the culture and opportunity
        for separation are still limited in Georgia. However, what I have seen over the past three months proves
        something radically different. From day to day, we observe the quantitative progress of the plastic collected in
        the boxes, and we are thinking of new initiatives that will further strengthen our environmental care efforts.
      </b>
    </p>

    <p class="right-align">Mariam, Customer Relations Specialist</p>

    <img src="../../../../assets/blog/recycling/img3.jpg" alt="" />

    <p class="quote-sign middle-green">“</p>

    <p>
      <b>
        It may seem strange to the reader, but leasing is one of the greenest products, as it does not encourage the
        short-term ownership of items by one owner but operates on the principle of sustainability. What is no longer
        needed by you may be beneficial to someone else. This is why we enthusiastically engage in initiatives that aim
        at environmental protection and reducing human harm.
      </b>
    </p>

    <p class="right-align">Ia, Head of Construction and Healthcare Sector</p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-middle-green">
      <div class="container">
        <p class="quote">
          Successful partnerships are just the beginning of the projects and activities inspired by the feedback from
          our employees. Therefore, keep an eye on us and get acquainted with the updates we plan in the field of green
          initiatives.
        </p>
      </div>
    </div>
  </div>
</ng-container>
